/* @jsx mdx */
  import React from 'react'
  import { mdx } from '@mdx-js/react'
  /* @jsx mdx */
import { Playground, Props } from 'docz'
import ToggleField from './'
import { Direction } from '../../common/direction'
import { Intent } from "../../common/intent";

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "togglefield"
    }}>{`ToggleField`}</h1>
    <p>{`Group of radios or checkboxes.`}</p>
    <p>{`'ToggleField' does not support indeterminate checkboxes.`}</p>
    <h2 {...{
      "id": "radios"
    }}>{`Radios`}</h2>
    <Playground __position={0} __code={'<ToggleField\n  type=\"radio\"\n  inputName=\"flavor\"\n  name=\"Whatchu want?\"\n  desc=\"Pick a flavor\"\n  mb={6}\n  options={[\n    {\n      label: \'I got orange\',\n      value: \'orange\',\n    },\n    {\n      label: \'I got grape\',\n      value: \'grape\',\n    },\n    {\n      label: \'I got blue\',\n      value: \'blue\',\n    },\n    {\n      label: \'I got nothing\',\n      value: \'nothing\',\n      disabled: true,\n    },\n  ]}\n/>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      ToggleField,
      Direction,
      Intent
    }} mdxType="Playground">
    <ToggleField type="radio" inputName="flavor" name="Whatchu want?" desc="Pick a flavor" mb={6} options={[{
        label: 'I got orange',
        value: 'orange'
      }, {
        label: 'I got grape',
        value: 'grape'
      }, {
        label: 'I got blue',
        value: 'blue'
      }, {
        label: 'I got nothing',
        value: 'nothing',
        disabled: true
      }]} mdxType="ToggleField" />
    </Playground>
    <h2 {...{
      "id": "checkboxes"
    }}>{`Checkboxes`}</h2>
    <Playground __position={1} __code={'<ToggleField\n  type=\"checkbox\"\n  inputName=\"flavors\"\n  name=\"Whatchu like?\"\n  desc=\"Snow cone flavors\"\n  direction={Direction.HORIZONTAL}\n  onChange={e => window.alert(e.target.value)}\n  options={[\n    {\n      label: \'Orange\',\n      value: \'orange\',\n    },\n    {\n      label: \'Grape\',\n      value: \'grape\',\n    },\n    {\n      label: \'Blue\',\n      value: \'blue\',\n    },\n    {\n      label: \'Gold\',\n      value: \'gold\',\n      disabled: true,\n    },\n  ]}\n/>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      ToggleField,
      Direction,
      Intent
    }} mdxType="Playground">
    <ToggleField type="checkbox" inputName="flavors" name="Whatchu like?" desc="Snow cone flavors" direction={Direction.HORIZONTAL} onChange={e => window.alert(e.target.value)} options={[{
        label: 'Orange',
        value: 'orange'
      }, {
        label: 'Grape',
        value: 'grape'
      }, {
        label: 'Blue',
        value: 'blue'
      }, {
        label: 'Gold',
        value: 'gold',
        disabled: true
      }]} mdxType="ToggleField" />
    </Playground>
    <h3 {...{
      "id": "proptypes"
    }}>{`PropTypes`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Prop`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Required`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Box props`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`see `}<a parentName="td" {...{
              "href": "/components/box"
            }}>{`Box`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`name`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`yes`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`type`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`yes`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`["radio", "checkbox"]`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`options`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`array`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`yes`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`see below`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`size`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`enum`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`Size.LARGE`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`affects name size. see `}<a parentName="td" {...{
              "href": "/common/size"
            }}>{`Size`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`inputSize`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`enum`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`Size.MEDIUM`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`passed to inputs. see `}<a parentName="td" {...{
              "href": "/common/size"
            }}>{`Size`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`inputName`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`required iff `}<inlineCode parentName="td">{`radio`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`required`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`bool`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`appends an asterisk to name`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`invalid`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`bool`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`passed to toggle components`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`direction`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`enum`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`VERTICAL`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`see `}<a parentName="td" {...{
              "href": "/common/direction"
            }}>{`Direction`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`desc`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`a description or hint`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`alert`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`bold message, typically used to signal invalid input`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`alertIntent`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`enum`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`Intent.DANGER`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`determines alert message color`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`onChange`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`function`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`receives selected value onChange`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`checkedIcon`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`uncheckedIcon`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`checkedColor`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`uncheckedColor`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "options-array-prop"
    }}><inlineCode parentName="h3">{`Options`}</inlineCode>{` array prop`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Prop`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Required`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`id`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`label`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`yes`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`value`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`yes`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`checked`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`bool`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`iff controlled`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`inputName`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`disabled`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`bool`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
        </tr>
      </tbody>
    </table>
    </MDXLayout>;
}

MDXContent.isMDXComponent = true;
  